<template>
  <div class="px-4 max-w-1068">
    <p class="o-heading-2 text-center mb-1" v-text="$t('Loyalty.LoyaltyProgram.NewLoyaltyPage.LoyaltyBenefits.LoyaltyProgramSummary')" />
    <div class="md:flex md:justify-center">
      <div
        v-for="(item, i) in items"
        :key="`${item.title}-${i}`"
        class="rounded bg-neutral-50 mt-5 p-5 md:flex-1 md:px-12 md:bg-transparent"
      >
        <OSvg :svg="item.svg" />
        <p class="o-heading-4 mt-5 mb-1 md:mb-2" v-text="item.title" />
        <p class="o-body" v-text="item.description" />
      </div>
    </div>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'
import { TrialDuration } from '@/enums/member'
import { DeliveryTimes } from '@/enums/shipments'
import { addLocalCurrency, getEuros } from '@/utils/general'
import { MenPrices } from '@/enums/products'
import { Currencies, WomenCountries } from '@/enums/general'

export default {
  name: 'LoyaltyBenefits',
  components: { OSvg },
  props: {
    country: {
      type: String,
      default: 'nl'
    },
    locale: {
      type: String,
      default: 'nl'
    }
  },
  computed: {
    isWomenCountry () {
      return WomenCountries.includes(this.country)
    },
    items () {
      const path = this.isWomenCountry ? 'Loyalty.LoyaltyProgram.NewLoyaltyPage.LoyaltyBenefits.MixedItems' : 'Loyalty.LoyaltyProgram.NewLoyaltyPage.LoyaltyBenefits.Items'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, i) => ({
        svg: this.$t(`${path}[${i}].Svg`),
        title: this.$t(`${path}[${i}].Title`, { ...this.variables }),
        description: this.$t(`${path}[${i}].Description`, { ...this.variables })
      }))
    },
    variables () {
      return {
        trialDuration: TrialDuration[this.country],
        earliest: DeliveryTimes[this.country].earliest,
        latest: DeliveryTimes[this.country].latest,
        loyaltyAmount: getEuros(this.country, 10),
        maxLoyaltyAmount: getEuros(this.country, 20),
        price: addLocalCurrency(MenPrices[this.country], `${this.locale}-${this.country.toUpperCase()}`, Currencies[this.country]),
        country: this.$t(`Countries.${this.country}`)
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.max-w-1068 {
  @apply mx-auto;
  max-width: 106.8rem;
}
</style>
